import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { DashboardShell } from "../../components/shared/DashboardShell";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { EmptyState, LoadingState, ErrorState } from "../../components/shared/EmptyState";
import { adminNav } from "../../components/shared/navConfig";
import { useApi, fmtDate } from "../../lib/useApi";

const V = { approved: "Verified", pending: "Pending", rejected: "Rejected", not_started: "Pending" };

export default function AdminCompanies() {
  const { data, loading, error, reload } = useApi("/admin/companies");
  const [q, setQ] = useState("");
  const rows = (data || []).filter(c => !q || `${c.company_name} ${c.email} ${c.city}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <DashboardShell nav={adminNav} title="Companies" subtitle={data ? `${data.length} registered companies` : "Registered companies"}>
      <div className="flex flex-wrap gap-2 mb-4">
        <input data-testid="companies-search-input" value={q} onChange={e => setQ(e.target.value)} placeholder="Search company, email or city…" className="flex-1 min-w-[200px] text-sm px-4 py-2.5 rounded-full border outline-none" style={{ borderColor: "var(--border-strong)", background: "var(--surface)", color: "var(--text)" }}/>
        <Link to="/admin/gst" data-testid="companies-gst-link" className="btn-ghost px-4 py-2.5 rounded-full text-xs">Review GST</Link>
      </div>
      <div className="card-surface p-4 sm:p-5">
        {loading ? <LoadingState/> : error ? <ErrorState message={error} onRetry={reload}/> : !rows.length ? (
          <EmptyState icon={Building2} title="No companies yet" desc="Companies appear here once they sign up and complete onboarding." testId="companies-empty"/>
        ) : (
          <table className="table-stack w-full text-sm">
            <thead><tr className="text-[10px] uppercase tracking-widest text-left" style={{ color: "var(--text-dim)" }}>
              <th className="pb-3 font-normal">Company</th><th className="pb-3 font-normal">City</th><th className="pb-3 font-normal">GSTIN</th><th className="pb-3 font-normal">Tasks</th><th className="pb-3 font-normal">Joined</th><th className="pb-3 font-normal text-right">Status</th>
            </tr></thead>
            <tbody>
              {rows.map(c => (
                <tr key={c.user_id} data-testid={`company-row-${c.user_id}`} className="border-t" style={{ borderColor: "var(--border)" }}>
                  <td className="py-3"><div style={{ color: "var(--text)" }}>{c.company_name}</div><div className="text-[11px]" style={{ color: "var(--text-dim)" }}>{c.email}{c.suspended ? " · Suspended" : ""}</div></td>
                  <td data-label="City" className="text-xs" style={{ color: "var(--text-muted)" }}><span>{c.city || "—"}</span></td>
                  <td data-label="GSTIN" className="text-xs font-mono break-all" style={{ color: "var(--text-muted)" }}><span>{c.gstin || "—"}</span></td>
                  <td data-label="Tasks" className="text-xs font-mono" style={{ color: "var(--text)" }}><span>{c.tasks}</span></td>
                  <td data-label="Joined" className="text-xs" style={{ color: "var(--text-muted)" }}><span>{fmtDate(c.created_at)}</span></td>
                  <td data-label="Status" className="text-right"><StatusBadge status={V[c.verification_status] || "Pending"}/></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardShell>
  );
}
